import { START_ICON_PATH, START_ICON_VIEWBOX } from '../constants/moTravel.constants';

interface MoStartIconProps {
  className?: string;
}

export function MoStartIcon({ className }: MoStartIconProps) {
  return (
    <svg viewBox={START_ICON_VIEWBOX} fill="currentColor" className={className} aria-hidden>
      <path d={START_ICON_PATH} />
    </svg>
  );
}
